import React, {useState} from 'react';
import {Link} from "react-router-dom";
import {_printNumber} from '../../helpers/helpers.js'
import {TagsPageResult, BiggestTag} from '../../../../server/routes/tag.js'

interface TAGPageProps {
	server: string;
	pageData: unknown;
}

export default function TAGPage({server, pageData}: TAGPageProps) {

    const typedPageData = pageData as TagsPageResult;
	const [data, setData] = useState(typedPageData);

	return (
        <>
            <TAGHeader props={data}/>
            <TAGBody props={data}/>
        </>
	)
}


interface TAGHeaderProps {
    props: TagsPageResult;
}

function TAGHeader({props}: TAGHeaderProps) {
    function handleSubmit(event: React.FormEvent<HTMLFormElement>): void {
        event.preventDefault();
        const q = document.getElementById('q') as HTMLInputElement;
        if (q) {
            const t = String(q.value).trim();
            document.location.href = '/tag/' + t;
        }
    }  
    return (
        <section className="section section-sm text-center">
            <div className="container">
                <div className="text-center">
                    <h2>Tag ID Lookup</h2>
                    <p>
                        <span style={{maxWidth: '690px'}}>
                        Find websites that use the same Tag ID
                        </span>
                    </p>
                </div>

                <div>			
                    <form className="rd-form rd-search form-inline" action="search" method="GET"  onSubmit={handleSubmit} >
                        <div className="form-wrap">
                            <input required type="text" className="form-input" title="Lookup websites by Tag Id" placeholder="Lookup Tag Id (for example G-123456)" name="q" id="q"/>
                        </div>
                        <div className="form-wrap form-button">
                            <button className="button button-secondary button-shadow" type="submit" >Search</button>
                        </div>
                    </form>
                </div>            
            </div>
        </section>
    )
}


interface TAGBodyProps {
    props: TagsPageResult;
}

function TAGBody({props}: TAGBodyProps) {
    if (!props.BiggestTags) return (<></>);
	return (
        <>
            <section className="section section-sm">
                <div className="container">
                    <div className="row row-50">
                        <div className="col-md-12 col-lg-12 col-xl-12">
                            <TAGList title='The largest domain clusters that share a common Tag ID' list={props.BiggestTags}/>
                        </div>
                    </div>
                </div>
            </section>
        </>
	)
}


interface TAGListProps {
    title: string;
    list: BiggestTag[];
}

function TAGList({title, list}: TAGListProps) {
return (
<>
    <h4>{title}</h4>    
    <br/>    
    <div className="table-outer table-rounded table-responsive-lg">
        <table className="table-custom table-custom-striped table-custom-primary  ">
            <thead>
            <tr>
                <th style={{width: '25%'}}>TagID</th>                
                <th style={{width: '55%'}}>Top Domain</th>                        
                <th style={{width: '20%'}}>Domain Count</th> 
            </tr>
            </thead>
                <tbody>
                {
                    list.map((tag, indexKey) => {
                        return (
                            <TAGRow tag={tag} key={indexKey}/>
                        )
                    })
                }	
            </tbody>
        </table>
    </div>
        
</>
)
}

interface TAGRowProps {
    tag: BiggestTag;
    requireAuthentication?: boolean;
}

function TAGRow({tag, requireAuthentication}: TAGRowProps) {
    if (!tag) return (<></>);

return (
    <>
    <tr>             
        <td>                
            <Link 
                to={`/tag/${tag.Tag}`} 
                className="link-hover" 
            >
                <b>{tag.Tag} </b>
            </Link> 	
        </td>         
        <td>                
            <Link 
                to={`/website/${tag.HighestRankDomain}`} 
                className="link-hover" 
            >
                <b>{tag.HighestRankDomain}</b>
            </Link> 
        </td>        
        <td>               
            {_printNumber(tag.DomainCount)}
        </td>
    </tr>		
    </>
)
}
